<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_nom">Nom</label>
      </div>
      <input id="equipe_nom"
             v-model="dataForm.nom"
             class="form-control"
             name="equipe_nom"
             placeholder="Entrez le nom de l'équipe"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="equipe_slogan">Slogan</label>
      </div>
      <input id="equipe_slogan"
             v-model="dataForm.slogan"
             class="form-control"
             name="equipe_slogan"
             placeholder="Entrez le slogan de l'équipe"
             type="text"
      >
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_date_creation_equipe">Date de création de l'équipe</label>
      </div>
      <input id="equipe_date_creation_equipe"
             v-model="dataForm.date_creation_equipe"
             class="form-control"
             name="equipe_date_creation_equipe"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_championnat">Championnat</label>
      </div>
      <select id="equipe_championnat"
              v-model="dataForm.championnat_id"
              class="custom-select"
              name="equipe_championnat">
        <option :value="championnat.championnat_id"
                :key="championnat.championnat_id.slice(5,15)"
                v-for="championnat in championnats">{{ championnat.nom }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_totem">Totem</label>
      </div>
      <input id="equipe_totem"
             v-model="dataForm.totem"
             class="form-control"
             name="equipe_totem"
             placeholder="Entrez le totem de l'équipe"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="fileToUpload">Logo</label>
      </div>
      <input id="fileToUpload"
             ref="fileToUpload"
             @change="handleFileToUpload"
             lang="fr"
             type="file"
             class="form-control"
             accept=".png, .jpeg, .jpg">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_historique">Historique</label>
      </div>
      <textarea id="equipe_historique"
                v-model="dataForm.historique"
                class="form-control"
                name="equipe_historique"
                placeholder="Entrez l'historique' de l'équipe"></textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_nom_complet_president">Noms du président</label>
      </div>
      <input id="equipe_nom_complet_president"
             v-model="dataForm.nom_complet_president"
             class="form-control"
             name="equipe_nom_complet_president"
             placeholder="Entrez le nom complet du président de l'équipe"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_president_telephone_1">Téléphones du président</label>
        <label class="input-group-text" for="equipe_president_telephone_2"></label>
      </div>
      <input id="equipe_president_telephone_1"
             v-model="dataForm.telephones_president"
             class="form-control"
             name="equipe_president_telephone_1"
             placeholder="Entrez le numéro prncipal du président"
             type="tel">
      <input id="equipe_president_telephone_2"
             v-model="dataForm.telephones_president"
             class="form-control"
             name="equipe_president_telephone_2"
             placeholder="Entrez le numéro secondaire du président"
             type="tel">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_nom_complet_secretaire">Noms du serétaire</label>
      </div>
      <input id="equipe_nom_complet_secretaire"
             v-model="dataForm.nom_complet_secretaire"
             class="form-control"
             name="equipe_nom_complet_secretaire"
             placeholder="Entrez le nom complet du secrétaire de l'équipe"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_secretaire_telephone_1">Téléphones du président</label>
        <label class="input-group-text" for="equipe_secretaire_telephone_2"></label>
      </div>
      <input id="equipe_secretaire_telephone_1"
             v-model="dataForm.telephones_secretaire"
             class="form-control"
             name="equipe_secretaire_telephone_1"
             placeholder="Entrez le numéro prncipal du secrétaire"
             type="tel">
      <input id="equipe_secretaire_telephone_2"
             v-model="dataForm.telephones_secretaire"
             class="form-control"
             name="equipe_secretaire_telephone_2"
             placeholder="Entrez le numéro secondaire du secrétaire"
             type="tel">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      championnats: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom: '',
        slogan: '',
        date_creation_equipe: '',
        championnat_id: '',
        totem: '',
        logo: '',
        description: '',
        historique: '',
        commentaires: '',
        nom_complet_president: '',
        telephones_president: '',
        nom_complet_secretaire: '',
        telephones_secretaire: '',
        table: 'equipes',
      },
      file: '',
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPostData',
      'axiosPostFileData',
    ]),
    handleFileToUpload(){
      this.file = this.$refs.fileToUpload.files[0];
    },
    uploadFileAndSendData () {
      let formData = new FormData()
      let fileName = ''
      if(this.dataForm.nom){
        fileName = this.dataForm.nom.split(' ').join('').toLowerCase() + Math.floor(Math.random() * 1000000) + 1
      }
      formData.append('fileToUpload', this.file)
      formData.append('fileName', fileName)
      formData.append('to', "equipes")
      if(this.file){
        this.axiosPostFileData(formData)
            .then(data => {
              this.dataForm.logo = data[2];
            })
            .catch(data => {
              console.log(data)
            })
      }
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201)
              this.messageSuccess = "Equipe ajoutée avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'insertion de l'équipe !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion de l'équipe !"
          })

    },
    onSubmit() {
      this.uploadFileAndSendData()
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    //
    this.axiosGetAllData({
      table: 'championnats'
    })
        .then((data) => {
          this.championnats = data.data
        })
        .catch((data) => {
          this.championnats = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/equipes/components/Create.vue